/*
 * Hotetec
 */
function factory({ window, document, thn }) {
    const engine = {};
    let hotetecUpdate;
    engine.onHashChange = function onHashChange(ctx) {
        if (window.location.hash.match(/^#roomDispo/)) {
            thn.widgets.price.update();
        }
    };
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const $ = window.jQuery;
        if (!hotetecUpdate) {
            hotetecUpdate = thn.debounce(() => ctx.widget.update(), 1000);
            $(document).off('change', 'select.selectChangeCurrency', hotetecUpdate);
            $(document).on('change', 'select.selectChangeCurrency', hotetecUpdate);
            thn.pageUnload(function () {
                $(document).off('change', 'select.selectChangeCurrency', hotetecUpdate);
                hotetecUpdate.cancel();
                hotetecUpdate = null;
            });
        }
    };
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        const noavail = $('#htt-filterResults .prh-availability .prh-info:visible').length > 0;
        const $results = $('.list-results:visible');
        if (noavail) {
            widgetData.noRooms = true;
        }
        else if ($results.length) {
            let room = $results.parent().attr('id').match(/roomDispo_\d+_(\d+)/);
            room = ((room && parseInt(room[1], 10)) || 1) - 1;
            widgetData.dateBegin = ($('input[name=dateFrom]').val() || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateEnd = ($('input[name=dateTo]').val() || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.rooms = 1; // just the one visible
            widgetData.adults = parseInt($(`[name="distribution[${room}].adults"]`).val(), 10) || 0;
            widgetData.children = $(`[name="distribution[${room}].childAge"]`).length || 0;
            widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
            const prices = $results.find('.price-night').map(function (idx, price) {
                return thn.parseNumber($(price).text());
            }).toArray();
            if (prices.length) {
                widgetData.price = Math.min(...prices);
                const currencyInfo = $('select.selectChangeCurrency').val().split('#');
                if (currencyInfo && currencyInfo.length >= 3) {
                    widgetData.currency = currencyInfo[2];
                }
                else if ($('.currency-text').text().length && thn.data.propertyId === 1024484) {
                    const currency = $('.currency-text').text().split(' ')[0];
                    widgetData.currency = thn.getCurrencyCode(currency) || 'CHF';
                }
                widgetData.set = true;
            }
        }
        return widgetData;
    };
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        const $detail = $('.data-room-detail[data-from][data-to]');
        if ($detail.length) {
            widgetData.dateBegin = ($detail.attr('data-from') || '').replace(/-/g, '/');
            widgetData.dateEnd = ($detail.attr('data-to') || '').replace(/-/g, '/');
        }
        const price = $('.total-price:visible strong').text();
        if (price) {
            widgetData.price = thn.parseNumber(price);
            const cur = price.match(/[^\d\s,.]+/);
            if (cur) {
                widgetData.currency = thn.getCurrencyCode(cur[0]);
            }
        }
        widgetData.bookingId = thn.trim(thn.parseUrlParameter('bookReference'));
        if (!widgetData.bookingId) {
            const id = $('.locator-code').text().trim();
            if (id) {
                widgetData.bookingId = id;
            }
        }
        return widgetData;
    };
    return engine;
}

export { factory };
